import React from 'react';
import { motion } from 'framer-motion';
interface LogosPathosProps {
  compact?: boolean;
}
const LOGOS = ['Proof', 'Evidence', 'Performance', 'Products'];
const PATHOS = ['Family', 'Humour', 'Personality', 'Recognition'];
const EASE = [0.22, 1, 0.36, 1];
const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.14,
      delayChildren: 0.05
    }
  }
};
const fromLeft = {
  hidden: {
    opacity: 0,
    x: -18
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: EASE
    }
  }
};
const fromRight = {
  hidden: {
    opacity: 0,
    x: 18
  },
  show: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.5,
      ease: EASE
    }
  }
};
const pop = {
  hidden: {
    opacity: 0,
    scale: 0.6
  },
  show: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.4,
      ease: EASE
    }
  }
};
const rise = {
  hidden: {
    opacity: 0,
    y: 16
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.55,
      ease: EASE
    }
  }
};

/** Logos + pathos = Meet the Filteks. Added to the rational story, not replacing it. */
export function LogosPathos({
  compact = false
}: LogosPathosProps) {
  return <motion.figure initial="hidden" whileInView="show" viewport={{
    once: true,
    amount: 0.3
  }} variants={container} className={['rounded-[24px] border border-[rgba(1,51,43,0.1)] bg-white', compact ? 'mt-6 p-4' : 'mt-8 p-6'].join(' ')} data-id="element-585" data-mp="25pl7e230uij5">
      <div className={compact ? 'flex flex-col gap-3' : 'grid grid-cols-[minmax(0,1fr)_auto_minmax(0,1fr)] items-stretch gap-4'} data-id="element-586" data-mp="20s1q0tb11pmz">
        <motion.div variants={fromLeft} className="rounded-[18px] border border-[rgba(1,51,43,0.14)] px-4 py-4" data-id="element-587" data-mp="2tfxni08f7lkt">
          <span className="block font-body text-[9px] uppercase tracking-[0.24em] text-[rgba(1,51,43,0.35)]" data-id="element-588" data-mp="2jqe1ilpevblq">
            Logos
          </span>
          <span className="mt-3 flex flex-wrap gap-1.5" data-id="element-589" data-mp="37fgirsg4v2fp">
            {LOGOS.map(word => <span key={word} className="rounded-full bg-[rgba(1,51,43,0.05)] px-2.5 py-1 font-body text-[11px] text-[rgba(1,51,43,0.6)]" data-id="element-590" data-mp="3c7qfbrbr70qy">
                {word}
              </span>)}
          </span>
        </motion.div>

        <motion.span variants={pop} aria-hidden="true" className="flex items-center justify-center font-heading text-[20px] text-[rgba(1,51,43,0.3)]" data-id="element-591" data-mp="3d1hahhbl4bhn">
          +
        </motion.span>

        <motion.div variants={fromRight} className="rounded-[18px] border border-[rgba(5,166,58,0.35)] bg-[rgba(5,221,77,0.07)] px-4 py-4" data-id="element-592" data-mp="335npranppbos">
          <span className="block font-body text-[9px] uppercase tracking-[0.24em] text-[#05a63a]" data-id="element-593" data-mp="2tdi0i8ouh8da">
            Pathos
          </span>
          <span className="mt-3 flex flex-wrap gap-1.5" data-id="element-594" data-mp="2pe93muyicudi">
            {PATHOS.map(word => <span key={word} className="rounded-full bg-white px-2.5 py-1 font-body text-[11px] text-background ring-1 ring-[rgba(5,166,58,0.25)]" data-id="element-595" data-mp="2kd1zr6zhkfc4">
                {word}
              </span>)}
          </span>
        </motion.div>
      </div>

      <motion.span variants={pop} aria-hidden="true" className="mt-4 flex items-center justify-center font-heading text-[18px] text-[rgba(1,51,43,0.3)]" data-id="element-596" data-mp="ztzm66w4qxlq">
        =
      </motion.span>

      <motion.div variants={rise} className="mt-4 rounded-[18px] bg-background px-5 py-6 text-center" data-id="element-597" data-mp="18u4pa4uaj9u3">
        <span className={['block font-heading leading-none tracking-[-0.02em] text-white', compact ? 'text-[24px]' : 'text-[30px]'].join(' ')} data-id="element-598" data-mp="h4t7qw2dcs5q">
          Meet the Filteks
        </span>
        <span className="mt-3 block font-body text-[10px] uppercase tracking-[0.2em] text-primary" data-id="element-599" data-mp="py6a0ombp64h">
          Clinical credibility with human connection
        </span>
      </motion.div>
    </motion.figure>;
}